import { render, staticRenderFns } from "./EditVm.vue?vue&type=template&id=1a877528&scoped=true"
import script from "./EditVm.vue?vue&type=script&lang=js"
export * from "./EditVm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a877528",
  null
  
)

export default component.exports